import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker, faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { toast } from "react-toastify";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import { search, finish } from "actions/trip-active/actions";

import MapPosition from "./map-position";
import CommonTable from "../../lib/components/CommonTable";
import Filters from "./filters";

const TripActive = ({
                       list,
                       search,
                       finish,
                       ...rest
                     }) => {
  const handleOpenMap = (position) => {
    if (!position || !Object.keys(position).length) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "trip-active-position",
      modalSettings: {
        size: "sm"
      },
      header: "Trip position",
      children: (
        <MapPosition
          coordinates={[position.longitude, position.latitude]}
          onCancel={() => rest.closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => rest.closeCustomModal(modalObj)
    };
    rest.openCustomModal(modalObj);
  };

  const handleFinish = id => {
    finish(id);
  };

  const getColumns = () => [
    {
      id: "ID",
      Header: "#",
      accessor: "id",
    },
    {
      id: "user",
      Header: "User",
      accessor: "user",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.user) {
          return (
            <Link to={`/users/${original.user}`}>
              {original.user}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "bike",
      Header: "Bike",
      accessor: "bike",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.bike) {
          return (
            <Link to={`/bikes/${original.bike}`}>
              {original.bike}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "scan",
      Header: "Scan",
      Cell: ({ original }) => moment(original.scan)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "start",
      Header: "Start",
      Cell: ({ original }) => moment(original.start)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "startPosition",
      Header: "Start Position",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleOpenMap(original.startPosition)}
          title="Start position"
        >
          <FontAwesomeIcon icon={faMapMarker}/>
        </button>
      )
    },
    {
      id: "end",
      Header: "End",
      Cell: ({ original }) => (original.end ? moment(original.end)
        .format("HH:mm YYYY-MM-DD") : null),
    },
    {
      id: "endPosition",
      Header: "End Position",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (original.endPosition
          ? <button
            className="btn btn-sm btn-primary"
            onClick={() => handleOpenMap(original.endPosition)}
            title="End position"
          >
            <FontAwesomeIcon icon={faMapMarker}/>
          </button>
          : null
      )
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Popconfirm
          title="Are you sure you want to finish this trip?"
          onConfirm={() => handleFinish(original.id)}
          placement="top"
          okText="Yes"
          cancelText="Cancel"
        >
          <button
            className="btn btn-sm btn-warning"
            title="Finish"
          >
            <FontAwesomeIcon icon={faCheckSquare}/>
          </button>
        </Popconfirm>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={search}
      FiltersComponent={Filters}
      searchHookProps={{
        size: 1000,
        sort: "start,DESC"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.tripActive.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  finish: bindActionCreators(finish, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(TripActive);



// WEBPACK FOOTER //
// ./src/views/pages/trip-active/index.js